"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_HOMECARE_FEEDBACK = exports.POST_HOMECARE_FEEDBACK = exports.GET_HOMECARE_FEEDBACK_QUESTIONAIRE = void 0;
const GET_HOMECARE_FEEDBACK_QUESTIONAIRE = exports.GET_HOMECARE_FEEDBACK_QUESTIONAIRE = 'getHomecareFeedbackQuestionaire';
const POST_HOMECARE_FEEDBACK = exports.POST_HOMECARE_FEEDBACK = 'postHomecareFeedbackQuestionaire';
const UPDATE_HOMECARE_FEEDBACK = exports.UPDATE_HOMECARE_FEEDBACK = 'updateHomecareFeedbackQuestionaire';